import React from "react";
import { Link } from "react-router-dom";
export default function BackdropsCTA() {
  return (
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04]
                        shadow-[0_22px_70px_rgba(0,0,0,0.70)] animate-fade-up">
          {/* gradient glow */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(227,67,100,0.22),transparent_55%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(159,92,255,0.18),transparent_55%)]" />

          <div className="relative px-6 py-10 md:px-10 md:py-12 text-center">
            <p className="text-xs uppercase tracking-[0.3em] text-pink-200 mb-2">
              Call Now
            </p>
            <h3 className="text-2xl md:text-4xl font-extrabold mb-4">
              Book Us For Your Next Event
            </h3>
            <p className="text-gray-200/90 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
              From weddings to corporate gatherings, PixlyBooth delivers premium,
              shareable moments your guests will love. Tell us your date and venue —
              we’ll recommend the best booth + backdrop combo.
            </p>

            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/book"
                className="inline-flex items-center justify-center rounded-full bg-[#E34364] px-6 py-2.5 text-sm font-semibold
                           shadow-[0_18px_45px_rgba(227,67,100,0.45)] hover:bg-[#f15477] transition"
              >
                Request a Quote
              </Link>

              <a
                href="tel:+10000000000"
                className="inline-flex items-center justify-center rounded-full bg-white/10 border border-white/15 px-6 py-2.5 text-sm font-semibold
                           hover:bg-white/15 transition"
              >
                Call Us
              </a>
            </div>

            <p className="mt-4 text-[12px] text-gray-400">
              Fast response • Professional setup • Custom branding available
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
